import { Box, Button } from "designSystem/index";
import Lightbox from "csi/middleware/lightbox/Lightbox";
import { ImageData } from "csi/model/image";
import React, { useState } from "react";
import image1 from "../images/turntable/1.png";
import image2 from "../images/turntable/2.png";
import image3 from "../images/turntable/3.png";
import image4 from "../images/turntable/4.png";
import image5 from "../images/turntable/5.png";
import image6 from "../images/turntable/6.png";
import image7 from "../images/turntable/7.png";
import image8 from "../images/turntable/8.png";
import veryTall from "../images/VeryTall.jpg";
import veryWide from "../images/VeryWide.jpg";
import image11 from "../images/11.jpg";
import image12 from "../images/12.jpg";
import image13 from "../images/13.jpg";
import image14 from "../images/14.jpg";
import image15 from "../images/15.jpg";
import image16 from "../images/16.jpg";
import image17 from "../images/17.jpg";
import image18 from "../images/18.jpg";
import image19 from "../images/19.jpg";
import image20 from "../images/20.jpg";
import image21 from "../images/21.jpg";
import image22 from "../images/22.jpg";
import image23 from "../images/23.jpg";
import image24 from "../images/24.jpg";
import image25 from "../images/25.jpg";
import image26 from "../images/26.jpg";
import image27 from "../images/27.jpg";

export default () => {
	const [open, setOpen] = useState(false);

	const gallery = [image1, image2, image3, image4, image5, image6, image7, image8];
	const toggleOpen = () => setOpen((open) => !open);

	const image1Data: ImageData = {
		imageKey: "1",
		lightboxGallerySrc: gallery,
		lightboxSrc: image1,
		thumbnailSrc: image1,
		name: "Image 1",
		isTurntable: true,
		width: 650,
		height: 650,
		dateCreated: "8/26/22",
		imageLabels: ["Front", "Marketing Image1", "Marketing Image2", "Marketing Image3", "Marketing Image4", "Marketing Image5", "Marketing Image6", "Marketing Image7", "Marketing Image8", "Marketing Image9", "Marketing Image10"],
		imageType: "png",
		imageSize: "305.58 KB",
	};
	const image2Data: ImageData = {
		imageKey: "2",
		lightboxSrc: image2,
		thumbnailSrc: image2,
		name: "Image 2",
		isTurntable: false,
		width: 650,
		height: 650,
		dateCreated: "8/27/22",
		imageLabels: ["Side", "Marketing Image"],
		imageType: "png",
		imageSize: "282.13 KB",
	};
	const image3Data: ImageData = {
		imageKey: "3",
		lightboxSrc: image3,
		thumbnailSrc: image3,
		name: "Image 3",
		isTurntable: false,
		width: 650,
		height: 650,
		dateCreated: "8/28/22",
		imageLabels: [],
		imageType: "png",
		imageSize: "192.91 KB",
	};
	const wideImage: ImageData = {
		imageKey: "4",
		lightboxSrc: veryWide,
		thumbnailSrc: veryWide,
		name: "Wide Image",
		isTurntable: false,
		width: 6680,
		height: 1776,
		dateCreated: "8/29/22",
		imageLabels: ["Wide", "Marketing Image"],
		imageType: "jpg",
		imageSize: "305.58 KB",
	};
	const tallImage: ImageData = {
		imageKey: "5",
		lightboxSrc: veryTall,
		thumbnailSrc: veryTall,
		name: "Tall Image",
		isTurntable: false,
		width: 2268,
		height: 4032,
		dateCreated: "8/29/22",
		imageLabels: ["Tall", "Marketing Image"],
		imageType: "jpg",
		imageSize: "305.58 KB",
	};
	const image11Data: ImageData = {
		imageKey: "11",
		lightboxSrc: image11,
		thumbnailSrc: image11,
		name: "Image 11",
		isTurntable: false,
		width: 1920,
		height: 2560,
		dateCreated: "10/21/22",
		imageLabels: [],
		imageType: "jpg",
		imageSize: "457KB",
	};
	const image12Data: ImageData = {
		imageKey: "12",
		lightboxSrc: image12,
		thumbnailSrc: image12,
		name: "Image 12",
		isTurntable: false,
		width: 1920,
		height: 2560,
		dateCreated: "10/21/22",
		imageLabels: [],
		imageType: "jpg",
		imageSize: "269KB",
	};
	const image13Data: ImageData = {
		imageKey: "13",
		lightboxSrc: image13,
		thumbnailSrc: image13,
		name: "Image 13",
		isTurntable: false,
		width: 2560,
		height: 1920,
		dateCreated: "10/21/22",
		imageLabels: [],
		imageType: "jpg",
		imageSize: "1.57MB",
	};
	const image14Data: ImageData = {
		imageKey: "14",
		lightboxSrc: image14,
		thumbnailSrc: image14,
		name: "Image 14",
		isTurntable: false,
		width: 1920,
		height: 2560,
		dateCreated: "10/21/22",
		imageLabels: [],
		imageType: "jpg",
		imageSize: "929KB",
	};
	const image15Data: ImageData = {
		imageKey: "15",
		lightboxSrc: image15,
		thumbnailSrc: image15,
		name: "Image 15",
		isTurntable: false,
		width: 1894,
		height: 2560,
		dateCreated: "10/21/22",
		imageLabels: [],
		imageType: "jpg",
		imageSize: "395KB",
	};
	const image16Data: ImageData = {
		imageKey: "16",
		lightboxSrc: image16,
		thumbnailSrc: image16,
		name: "Image 16",
		isTurntable: false,
		width: 2048,
		height: 643,
		dateCreated: "10/21/22",
		imageLabels: [],
		imageType: "jpg",
		imageSize: "201KB",
	};
	const image17Data: ImageData = {
		imageKey: "17",
		lightboxSrc: image17,
		thumbnailSrc: image17,
		name: "Image 17",
		isTurntable: false,
		width: 1024,
		height: 683,
		dateCreated: "10/21/22",
		imageLabels: [],
		imageType: "jpg",
		imageSize: "205KB",
	};
	const image18Data: ImageData = {
		imageKey: "18",
		lightboxSrc: image18,
		thumbnailSrc: image18,
		name: "Image 18",
		isTurntable: false,
		width: 1024,
		height: 683,
		dateCreated: "10/21/22",
		imageLabels: [],
		imageType: "jpg",
		imageSize: "253KB",
	};
	const image19Data: ImageData = {
		imageKey: "19",
		lightboxSrc: image19,
		thumbnailSrc: image19,
		name: "Image 19",
		isTurntable: false,
		width: 1024,
		height: 683,
		dateCreated: "10/21/22",
		imageLabels: [],
		imageType: "jpg",
		imageSize: "225KB",
	};
	const image20Data: ImageData = {
		imageKey: "20",
		lightboxSrc: image20,
		thumbnailSrc: image20,
		name: "Image 20",
		isTurntable: false,
		width: 1024,
		height: 640,
		dateCreated: "10/21/22",
		imageLabels: [],
		imageType: "jpg",
		imageSize: "422KB",
	};
	const image21Data: ImageData = {
		imageKey: "21",
		lightboxSrc: image21,
		thumbnailSrc: image21,
		name: "Image 21",
		isTurntable: false,
		width: 1024,
		height: 683,
		dateCreated: "10/21/22",
		imageLabels: [],
		imageType: "png",
		imageSize: "225KB",
	};
	const image22Data: ImageData = {
		imageKey: "22",
		lightboxSrc: image22,
		thumbnailSrc: image22,
		name: "Image 22",
		isTurntable: false,
		width: 1424,
		height: 896,
		dateCreated: "8/28/22",
		imageLabels: [],
		imageType: "jpg",
		imageSize: "457KB",
	};
	const image23Data: ImageData = {
		imageKey: "23",
		lightboxSrc: image23,
		thumbnailSrc: image23,
		name: "Image 23",
		isTurntable: false,
		width: 4912,
		height: 4912,
		dateCreated: "10/21/22",
		imageLabels: [],
		imageType: "png",
		imageSize: "1.23MB",
	};
	const image24Data: ImageData = {
		imageKey: "24",
		lightboxSrc: image24,
		thumbnailSrc: image24,
		name: "Image 24",
		isTurntable: false,
		width: 2124,
		height: 2940,
		dateCreated: "10/21/22",
		imageLabels: [],
		imageType: "png",
		imageSize: "556KB",
	};
	const image25Data: ImageData = {
		imageKey: "25",
		lightboxSrc: image25,
		thumbnailSrc: image25,
		name: "Image 25",
		isTurntable: false,
		width: 5184,
		height: 3456,
		dateCreated: "10/21/22",
		imageLabels: [],
		imageType: "png",
		imageSize: "2.76MB",
	};
	const image26Data: ImageData = {
		imageKey: "26",
		lightboxSrc: image26,
		thumbnailSrc: image26,
		name: "Image 26",
		isTurntable: false,
		width: 994,
		height: 994,
		dateCreated: "10/21/22",
		imageLabels: [],
		imageType: "png",
		imageSize: "562KB",
	};
	const image27Data: ImageData = {
		imageKey: "27",
		lightboxSrc: image27,
		thumbnailSrc: image27,
		name: "Image 27",
		isTurntable: false,
		width: 3721,
		height: 3721,
		dateCreated: "10/21/22",
		imageLabels: [],
		imageType: "png",
		imageSize: "1.33MB",
	};

	const images = [image1Data, image2Data, image3Data,
		wideImage, tallImage, image2Data,
		image11Data, image12Data, image13Data, image14Data, image15Data, image16Data,
		image17Data, image18Data, image19Data, image20Data, image21Data, image22Data,
		image23Data, image24Data, image25Data, image26Data, image27Data,
		wideImage, tallImage, image2Data];

	return (
		<Box>
			<Button design="primary" onClick={toggleOpen}>
				Lightbox
			</Button>
			{!!open &&
				<Lightbox images={images} onClose={toggleOpen} />
			}
		</Box>
	);
};
